var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"deal-container"},[_c('configuration-duplicate-deal',{attrs:{"raw-groups":_vm.groupsRaw}}),_c('change-responsible-in-bulk',{attrs:{"raw-groups":_vm.groupsRaw}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }